export default "__VITE_ASSET__BqGmu4fp__";